// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kRsM","field":"styles_field__1vjex","fieldCol":"styles_fieldCol__1O69z","diffCol":"styles_diffCol__8XDHk","diff":"styles_diff__14wnt"};